(() => {
  const MOBILE_BREAKPOINT = 767;
  const instances = new Map();

  const shouldUseSwiper = () => window.innerWidth <= MOBILE_BREAKPOINT;

  const isVisible = (el) => !!(el && el.offsetParent !== null);

  const waitForSwiper = (callback, retry = 0) => {
    if (typeof window.Swiper === "function") {
      callback();
      return;
    }
    if (retry > 20) return;
    setTimeout(() => waitForSwiper(callback, retry + 1), 120);
  };

  const destroySwiper = (sectionId) => {
    const instance = instances.get(sectionId);
    if (!instance) return;
    instance.destroy(true, true);
    instances.delete(sectionId);
  };

  const initSwiper = (sectionEl) => {
    const sectionId = sectionEl.id;
    const swiperEl = sectionEl.querySelector(".p-image-html__media-swiper-wrap .p-image-html__media-swiper");

    if (!swiperEl || swiperEl.querySelectorAll(".swiper-slide").length < 2) {
      destroySwiper(sectionId);
      return;
    }

    if (!shouldUseSwiper() || !isVisible(swiperEl)) {
      destroySwiper(sectionId);
      return;
    }

    if (instances.has(sectionId)) return;

    const sid = sectionId.replace("p-image-html-", "");

    instances.set(
      sectionId,
      new window.Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: `#pih-pagination-${sid}`,
          type: "progressbar"
        },
        navigation: {
          nextEl: `#pih-next-${sid}`,
          prevEl: `#pih-prev-${sid}`
        }
      })
    );
  };

  const syncAll = () => {
    document.querySelectorAll(".p-image-html__media--swiper-m").forEach((mediaEl) => {
      const sectionEl = mediaEl.closest(".p-image-html");
      if (!sectionEl) return;

      if (shouldUseSwiper()) {
        initSwiper(sectionEl);
      } else {
        destroySwiper(sectionEl.id);
      }
    });
  };

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 150);
  });

  window.PImageHtmlSwiper = {
    init(selector) {
      waitForSwiper(() => {
        const sectionEl = document.querySelector(selector);
        if (!sectionEl) return;
        destroySwiper(sectionEl.id);
        initSwiper(sectionEl);
      });
    }
  };
})();
